/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { ISolicitarRemessaRepository } from "@/interface/solicitar-remessa";

const solicitarRemessaRepository: ISolicitarRemessaRepository = {
  /**
   * Função para solicitar remessa
   * @param payload
   * @param accessToken
   * @returns Promise<any | null>
   */

  async handlerSolicitarRemessa(accessToken, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const remessaSolicitada = await Instance.post(`remessas`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
        accept: "*/*",
      },
    });

    return remessaSolicitada?.data;
  },
};

/**
 * EXPORTS
 */
export { solicitarRemessaRepository };
